import { render } from "./QAChooser.vue?vue&type=template&id=6f3fa770&scoped=true"
import script from "./QAChooser.vue?vue&type=script&lang=js"
export * from "./QAChooser.vue?vue&type=script&lang=js"

import "./QAChooser.vue?vue&type=style&index=0&id=6f3fa770&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f3fa770"]])

export default __exports__